import BookingApiUtils from '../utils/api/booking';
import {
  addMessage as addModalMessage,
  hide as hideModal,
} from './modal';
import { addMessage as addFlashMessage } from './flash';
import { useSecondaryModalStore } from '../stores';

// Helper to hide secondary modal from Redux thunks
const hideSecondaryModal = () => useSecondaryModalStore.getState().hide();

export const BOOK_SENT = 'BOOK_SENT';
export const BOOK_SUCCEEDED = 'BOOK_SUCCEEDED';
export const BOOK_FAILED = 'BOOK_FAILED';
export const CANCEL_BOOKING_SENT = 'CANCEL_BOOKING_SENT';
export const CANCEL_BOOKING_SUCCEEDED = 'CANCEL_BOOKING_SUCCEEDED';
export const CANCEL_BOOKING_FAILED = 'CANCEL_BOOKING_FAILED';
export const CANCEL_BOOKING_BY_TUTOR_SENT = 'CANCEL_BOOKING_BY_TUTOR_SENT';
export const CANCEL_BOOKING_BY_TUTOR_SUCCEEDED =
  'CANCEL_BOOKING_BY_TUTOR_SUCCEEDED';
export const CANCEL_BOOKING_BY_TUTOR_FAILED = 'CANCEL_BOOKING_BY_TUTOR_FAILED';
export const FETCH_MY_BOOKINGS_SENT = 'FETCH_MY_BOOKINGS_SENT';
export const FETCH_MY_BOOKINGS_SUCCEEDED = 'FETCH_MY_BOOKINGS_SUCCEEDED';
export const FETCH_MY_BOOKINGS_FAILED = 'FETCH_MY_BOOKINGS_FAILED';
export const FETCH_STUDENT_BOOKINGS_SENT = 'FETCH_STUDENT_BOOKINGS_SENT';
export const FETCH_STUDENT_BOOKINGS_SUCCEEDED =
  'FETCH_STUDENT_BOOKINGS_SUCCEEDED';
export const FETCH_STUDENT_BOOKINGS_FAILED = 'FETCH_STUDENT_BOOKINGS_FAILED';
export const FETCH_TUTOR_BOOKINGS_SENT = 'FETCH_TUTOR_BOOKINGS_SENT';
export const FETCH_TUTOR_BOOKINGS_SUCCEEDED = 'FETCH_TUTOR_BOOKINGS_SUCCEEDED';
export const FETCH_TUTOR_BOOKINGS_FAILED = 'FETCH_TUTOR_BOOKINGS_FAILED';
export const FETCH_MY_BOOKING_SENT = 'FETCH_MY_BOOKING_SENT';
export const FETCH_MY_BOOKING_SUCCEEDED = 'FETCH_MY_BOOKING_SUCCEEDED';
export const FETCH_MY_BOOKING_FAILED = 'FETCH_MY_BOOKING_FAILED';

function addTeamsFieldsToBooking(booking) {
  if (!booking) {
    return booking;
  }
  return {
    ...booking,
    communication_platform: booking.communication_platform ?? null,
    tutor_teams_email: booking.tutor_teams_email ?? null,
    student_teams_email: booking.student_teams_email ?? null,
  };
}

function addTeamsFieldsToPayload(data) {
  if (!data) {
    return data;
  }
  const next = { ...data };
  if (next.booking) {
    next.booking = addTeamsFieldsToBooking(next.booking);
  }
  if (next.bookings) {
    next.bookings = next.bookings.map(addTeamsFieldsToBooking);
  }
  return next;
}

function addToLocalStorage(data) {
  localStorage.setItem('authToken', data.authToken);
  localStorage.setItem('profile', data.profile);
  localStorage.setItem('user', JSON.stringify(data.user));
}

export function bookSent() {
  return { type: BOOK_SENT };
}

export function bookSucceeded(data) {
  return {
    type: BOOK_SUCCEEDED,
    payload: addTeamsFieldsToPayload(data),
  };
}

export function bookFailed(error) {
  return { type: BOOK_FAILED };
}

export function cancelSent() {
  return { type: CANCEL_BOOKING_SENT };
}

export function cancelSucceeded(data) {
  return {
    type: CANCEL_BOOKING_SUCCEEDED,
    payload: addTeamsFieldsToPayload(data),
  };
}

export function cancelFailed(error) {
  return { type: CANCEL_BOOKING_FAILED };
}

export function cancelByTutorSent() {
  return { type: CANCEL_BOOKING_BY_TUTOR_SENT };
}

export function cancelByTutorSucceeded(data) {
  return {
    type: CANCEL_BOOKING_BY_TUTOR_SUCCEEDED,
    payload: addTeamsFieldsToPayload(data),
  };
}

export function cancelByTutorFailed(error) {
  return { type: CANCEL_BOOKING_BY_TUTOR_FAILED };
}

export function fetchStudentBookingsSent() {
  return { type: FETCH_STUDENT_BOOKINGS_SENT };
}

export function fetchStudentBookingsSucceeded(data) {
  return {
    type: FETCH_STUDENT_BOOKINGS_SUCCEEDED,
    payload: addTeamsFieldsToPayload(data),
  };
}

export function fetchStudentBookingsFailed(error) {
  return { type: FETCH_STUDENT_BOOKINGS_FAILED };
}

export function fetchTutorBookingsSent() {
  return { type: FETCH_TUTOR_BOOKINGS_SENT };
}

export function fetchTutorBookingsSucceeded(data) {
  return {
    type: FETCH_TUTOR_BOOKINGS_SUCCEEDED,
    payload: addTeamsFieldsToPayload(data),
  };
}

export function fetchTutorBookingsFailed(error) {
  return { type: FETCH_TUTOR_BOOKINGS_FAILED };
}

export function fetchMyBookingSent() {
  return { type: FETCH_MY_BOOKING_SENT };
}

export function fetchMyBookingSucceeded(data) {
  return {
    type: FETCH_MY_BOOKING_SUCCEEDED,
    payload: addTeamsFieldsToPayload(data),
  };
}

export function fetchMyBookingFailed(error) {
  return { type: FETCH_MY_BOOKING_FAILED };
}

export function fetchMyBookingsSent(page) {
  return {
    type: FETCH_MY_BOOKINGS_SENT,
    payload: { page },
  };
}

export function fetchMyBookingsSucceeded(data) {
  return {
    type: FETCH_MY_BOOKINGS_SUCCEEDED,
    payload: addTeamsFieldsToPayload(data),
  };
}

export function fetchMyBookingsFailed(error) {
  return { type: FETCH_MY_BOOKINGS_FAILED };
}

export function book(
  tutorId,
  startTimestamp,
  endTimestamp,
  ticketCost,
  subTicketCost,
  fromModal = false,
  closeModal = false,
) {
  return (dispatch) => {
    dispatch(bookSent());
    return BookingApiUtils.book(
      tutorId,
      startTimestamp,
      endTimestamp,
      ticketCost,
      subTicketCost,
    ).then(
      (data) => {
        addToLocalStorage(data);
        dispatch(bookSucceeded(data));
        hideSecondaryModal();
        if (fromModal && !closeModal) {
          dispatch(
            addModalMessage(data.message, {
              autoDisappear: true,
              type: 'success',
            }),
          );
        } else {
          dispatch(
            addFlashMessage(data.message, {
              autoDisappear: true,
              sticky: true,
              type: 'success',
            }),
          );
        }
        if (closeModal) dispatch(hideModal());
      },
      (error) => {
        dispatch(bookFailed(error));
        hideSecondaryModal();
        dispatch(
          addModalMessage(error.message, {
            autoDisappear: false,
            type: 'error',
          }),
        );
      },
    );
  };
}

export function cancel(bookingId, page, fromModal = false) {
  return (dispatch) => {
    dispatch(cancelSent());
    return BookingApiUtils.cancel(bookingId, page).then(
      (data) => {
        addToLocalStorage(data);
        dispatch(cancelSucceeded(data));
        hideSecondaryModal();
        if (fromModal) {
          dispatch(
            addModalMessage(data.message, {
              autoDisappear: true,
              type: 'success',
            }),
          );
        } else {
          dispatch(
            addFlashMessage(data.message, {
              autoDisappear: true,
              sticky: true,
              type: 'success',
            }),
          );
        }
      },
      (error) => {
        dispatch(cancelFailed(error));
        hideSecondaryModal();
        if (fromModal) {
          dispatch(
            addModalMessage(error.message, {
              autoDisappear: false,
              type: 'error',
            }),
          );
        } else {
          dispatch(
            addFlashMessage(error.message, {
              autoDisappear: true,
              sticky: true,
              type: 'error',
            }),
          );
        }
      },
    );
  };
}

export function cancelByTutor(bookingId, reason, comment) {
  return (dispatch) => {
    dispatch(cancelByTutorSent());
    return BookingApiUtils.cancelByTutor(bookingId, reason, comment).then(
      (data) => {
        dispatch(cancelByTutorSucceeded(data));
        dispatch(hideModal());
        dispatch(
          addFlashMessage('Succefully unscheduled the booking', {
            autoDisappear: true,
            sticky: true,
            type: 'success',
          }),
        );
      },
      (error) => {
        dispatch(cancelByTutorFailed(error));
        dispatch(
          addModalMessage(error.message, {
            autoDisappear: false,
            type: 'error',
          }),
        );
      },
    );
  };
}

export function fetchStudentBookings(studentId, page) {
  return (dispatch) => {
    dispatch(fetchStudentBookingsSent());
    return BookingApiUtils.fetchStudentBookings(studentId, page).then(
      (data) => dispatch(fetchStudentBookingsSucceeded(data)),
      (error) => dispatch(fetchStudentBookingsFailed(error)),
    );
  };
}

export function fetchTutorBookings(tutorId, page) {
  return (dispatch) => {
    dispatch(fetchTutorBookingsSent());
    return BookingApiUtils.fetchTutorBookings(tutorId, page).then(
      (data) => dispatch(fetchTutorBookingsSucceeded(data)),
      (error) => dispatch(fetchTutorBookingsFailed(error)),
    );
  };
}

export function fetchMyBooking(id) {
  return (dispatch) => {
    dispatch(fetchMyBookingSent());
    return BookingApiUtils.fetchOne(id).then(
      (data) => dispatch(fetchMyBookingSucceeded(data)),
      (error) => dispatch(fetchMyBookingFailed(error)),
    );
  };
}

export function fetchMyBookings(page = null) {
  return (dispatch) => {
    dispatch(fetchMyBookingsSent(page));
    return BookingApiUtils.fetchMyBookings(page).then(
      (data) => dispatch(fetchMyBookingsSucceeded(data)),
      (error) => dispatch(fetchMyBookingsFailed(error)),
    );
  };
}
